import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";

import MKTypography from "components/MKTypography";
import intro1 from "assets/images/clients/intros/ios/ios-intro-01.png";
import intro2 from "assets/images/clients/intros/ios/ios-intro-02.png";

function IOSDesc() {
  const { t } = useTranslation();

  return (
    <Card
      sx={{
        p: { xs: 2, md: 3 },
        mx: { xs: 2, lg: 3 },
        mt: 2,
        mb: 2,
        boxShadow: ({ boxShadows: { lg } }) => lg,
      }}
    >
      <MKTypography variant="h5" fontWeight="bold" mb={1}>
        {t("clients.ios.desc.title")}
      </MKTypography>

      <Grid container spacing={2} alignItems="center" sx={{ mb: 2 }}>
        <Grid item xs={12} md={5}>
          <Box
            component="img"
            src={intro1}
            alt="iOS intro step 1"
            sx={{
              width: "100%",
              display: "block",
              borderRadius: 1,
              border: "1px solid",
              borderColor: "grey.300",
            }}
          />
        </Grid>
        <Grid item xs={12} md={7}>
          <MKTypography variant="h6" fontWeight="bold" mb={0.5}>
            {t("clients.ios.desc.section1Title")}
          </MKTypography>
          <MKTypography variant="body2" color="text" sx={{ whiteSpace: "pre-line" }}>
            {t("clients.ios.desc.section1Body")}
          </MKTypography>
        </Grid>
      </Grid>

      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} md={5}>
          <Box
            component="img"
            src={intro2}
            alt="iOS intro step 2"
            sx={{
              width: "100%",
              display: "block",
              borderRadius: 1,
              border: "1px solid",
              borderColor: "grey.300",
            }}
          />
        </Grid>
        <Grid item xs={12} md={7}>
          <MKTypography variant="h6" fontWeight="bold" mb={0.5}>
            {t("clients.ios.desc.section2Title")}
          </MKTypography>
          <MKTypography variant="body2" color="text" sx={{ whiteSpace: "pre-line" }}>
            {t("clients.ios.desc.section2Body")}
          </MKTypography>
        </Grid>
      </Grid>
    </Card>
  );
}

export default IOSDesc;
